import useSearchParams from "hooks/useSearchParams";
import { Container } from "layouts";
import PaddingX from "layouts/PaddingX";
import { BiCheck } from "react-icons/bi";
import { Link } from "react-router-dom";
import AppDownloadLinks from "components/v2/AppDownloadLinks";

const PaymentSuccessResponse = () => {
	const { getParam } = useSearchParams();
	const paymentMethod = getParam("payment_method");

	return (
		<Container>
			<PaddingX>
				<div className="mt-10 lg:mt-24 max-w-lg mx-auto bg-white rounded-lg p-6">
					<div className="flex flex-col justify-center items-center">
						<div className="flex justify-center items-center mb-4">
							<div className="bg-green-50 p-4 rounded-full">
								<BiCheck
									size={80}
									className="text-akgreener"
								/>
							</div>
						</div>

						<div className="flex flex-col items-center gap-3 text-center w-full">
							<h1 className="text-2xl font-bold text-gray-700">
								Payment Successful
							</h1>
							<p className="text-gray-600 mb-2">
								Your <span className="font-medium">{paymentMethod}</span>{" "}
								payment was processed successfully
							</p>

							<div className="my-5 pt-5 border-t border-gray-200 w-full text-center">
								<p className="text-gray-600 mb-4">
									You can now access all your purchased books in your library
								</p>

								<div className="flex flex-col sm:flex-row gap-3 justify-center mt-2">
									<Link
										to="/"
										className="px-4 py-2 bg-gray-100 text-gray-700 font-medium rounded-md transition-all hover:bg-gray-200"
									>
										Back to home
									</Link>
									<Link
										to="/my-library"
										className="px-4 py-2 bg-akgreener text-white font-medium rounded-md transition-all hover:bg-akgreen"
									>
										Go to my library
									</Link>
								</div>
							</div>

							{/* Prominent App Download Section */}
							<AppDownloadLinks className="w-full mt-4" />
						</div>
					</div>
				</div>
			</PaddingX>
		</Container>
	);
};

export default PaymentSuccessResponse;
